import _ from 'lodash';
import { useState, useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

const propTypes = {
  children: PropTypes.element,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  size: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
  shouldConfirmClose: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  okBtnTitle: PropTypes.string,
  onCancel: PropTypes.func,
  cancelBtnTitle: PropTypes.string,
  btnClassName: PropTypes.string,
  backdrop: PropTypes.string,
  onSaveid: PropTypes.string,
  modalSaveButtonProps: PropTypes.shape({}),
  isOkBtnDisabled: PropTypes.bool,
  shouldShow: PropTypes.bool,
  shouldShowCloseButton: PropTypes.bool,
};

const defaultProps = {
  children: null,
  onSave: null,
  title: '',
  okBtnTitle: 'Save',
  size: '',
  message: null,
  className: '',
  onClose: _.noop,
  shouldConfirmClose: false,
  onCancel: null,
  cancelBtnTitle: 'Cancel',
  btnClassName: '',
  backdrop: '',
  onSaveid: '',
  modalSaveButtonProps: {},
  isOkBtnDisabled: false,
  shouldShow: true,
  shouldShowCloseButton: true,
};
// TODO: change to TypeScript
const ModalComponent = ({
  children,
  onSave,
  onClose,
  title,
  size,
  message,
  className,
  shouldConfirmClose,
  okBtnTitle,
  onCancel,
  cancelBtnTitle,
  btnClassName,
  backdrop,
  onSaveid,
  modalSaveButtonProps,
  isOkBtnDisabled,
  shouldShow,
  shouldShowCloseButton,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleHide = useCallback(() => {
    if (_.isFunction(shouldConfirmClose) ? shouldConfirmClose() : shouldConfirmClose) {
      setIsClosing(true);
    } else {
      onClose();
    }
  }, [shouldConfirmClose, onClose]);

  const onConfirmedClose = () => {
    setIsClosing(false);
    onClose();
  };

  const renderCloseConfirmation = () => (
    <>
      <div className="modal-body confirmation-modal-body">
        <figure />
        <div className="confirmation-window text-center">
          <h5 className="tx-22">Confirmation</h5>
          <i className="fa-regular fa-circle-info tx-35 mb-3 mt-3 " />
          <p className="m-0">Are you sure to close without saving</p>
        </div>
      </div>

      <div className="modal-footer d-flex align-items-center flex-nowrap confirmation-modal-footer">
        <button
          type="button"
          className="btn btn-lg btn-outline-primary btn-block me-2"
          onClick={onConfirmedClose}
        >
          Yes
        </button>

        <button
          type="button"
          autoFocus
          className="btn btn-lg btn-primary btn-block m-0"
          onClick={() => setIsClosing(false)}
        >
          No
        </button>
      </div>
    </>
  );

  const renderModalFooter = () => {
    const isShow = message || onSave || onCancel;
    if (!isShow) return null;

    return (
      <Modal.Footer>
        {message && <div className="alert alert-danger">{message}</div>}
        {onCancel && (
          <Button variant="outline-danger" onClick={onCancel}>
            {cancelBtnTitle}
          </Button>
        )}
        {onSave && (
          <Button
            {...modalSaveButtonProps}
            variant="primary"
            className={btnClassName}
            onClick={onSave}
            id={onSaveid}
            disabled={isOkBtnDisabled}
          >
            {okBtnTitle}
          </Button>
        )}
      </Modal.Footer>
    );
  };

  let modalProps = {
    size: isClosing ? 'sm' : size,
    show: shouldShow,
    onHide: handleHide,
    className: `${className} ${isClosing ? 'confirmation-modal' : ''}`,
    centered: true,
    'aria-labelledby': 'contained-modal-title-vcenter',
  };

  if (backdrop) modalProps.backdrop = backdrop;

  return (
    <Modal {...modalProps}>
      {isClosing ? (
        renderCloseConfirmation()
      ) : (
        <>
          <Modal.Header closeButton={shouldShowCloseButton}>
            <Modal.Title id="contained-modal-title-vcenter">{ReactHtmlParser(title)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{children}</Modal.Body>
          {renderModalFooter()}
        </>
      )}
    </Modal>
  );
};

ModalComponent.propTypes = propTypes;
ModalComponent.defaultProps = defaultProps;

export default ModalComponent;
